import React from 'react';
import logoImg from '../assets/logo-removebg-preview.png';

const PageLoader = () => (
  <div style={{
    position: 'fixed', inset: 0, zIndex: 9999,
    background: '#fff',
    display: 'flex', flexDirection: 'column',
    alignItems: 'center', justifyContent: 'center',
    gap: '24px',
  }}>
    <style>{`
      @keyframes loaderPulse {
        0%, 100% { transform: scale(1); opacity: 1; }
        50%       { transform: scale(1.08); opacity: 0.85; }
      }
      @keyframes loaderDots {
        0%, 80%, 100% { opacity: 0.2; transform: scale(0.8); }
        40%            { opacity: 1;   transform: scale(1); }
      }
      .pl-logo {
        width: 200px;
        animation: loaderPulse 1.4s ease-in-out infinite;
      }
      .pl-dots {
        display: flex; gap: 8px; align-items: center;
      }
      .pl-dot {
        width: 8px; height: 8px; border-radius: 50%;
        background: linear-gradient(135deg, #3a8fa3, #5aab9a);
        animation: loaderDots 1.2s ease-in-out infinite;
      }
      .pl-dot:nth-child(2) { animation-delay: 0.2s; }
      .pl-dot:nth-child(3) { animation-delay: 0.4s; }
      .pl-text {
        font-family: 'Outfit', sans-serif;
        font-size: 0.72rem; font-weight: 600;
        letter-spacing: 0.2em; text-transform: uppercase;
        color: #3a8fa3; opacity: 0.65;
      }
    `}</style>

    <img src={logoImg} alt="Curevion Saludis" className="pl-logo" />
    <div className="pl-dots">
      <div className="pl-dot" />
      <div className="pl-dot" />
      <div className="pl-dot" />
    </div>
    <div className="pl-text">Loading</div>
  </div>
);

export default PageLoader;